import {
	Box,
	FormControl,
	FormControlLabel,
	Checkbox,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import { TERMS } from "../../../../config/terminology";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const LW = sizes.w650;
const MW = sizes.w300;

export default function AuthorizedDeviation() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		quotaDeviationPercentage,
		modificationDeviationPercentage,
		emailNotification,
		email,
	} = setupState;

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};
	const handleCheckedUpdate = (event, stateName) => {
		const option = event.target.checked;
		dispatch(setState(stateName, option));
	};

	return (
		<>
			<Box sx={{ mt: 2, p: 2, border: 1, borderRadius: 1, borderColor: "#c6c6c6" }}>
				<Box sx={{ mt: 0 }}>
					<Typography sx={{ color: "black.main", fontWeight: "600", fontSize: "14px" }}>
						Authorised Deviation %
					</Typography>
				</Box>
				<Box>
					<Grid container columns={12} columnSpacing={1} alignContent={"space-between"} >
						<Grid item sm={6} md={6} xs = {6}>
							<Box>
								<TextField
									type={"number"}
									id="outlined-basic"
									label={`Define ${TERMS.QUOTA} vs Revised/Approved ${TERMS.QUOTA}`}
									variant="outlined"
									size="small"
									sx={{
										width: "100%",
										mt : 3
									}}
									value={quotaDeviationPercentage}
									onChange={(event) => {
										const inputValue = parseFloat(event.target.value);
										if (isNaN(inputValue) || inputValue >= 0) {
											handleStateUpdate(event, "quotaDeviationPercentage");
										}
									}}
									InputProps={{ autoComplete: "off" }}
								/>
							</Box>
						</Grid>

						<Grid item sm={6} md={6} xs = {6}>
							<Box>
								<TextField
									type={"number"}
									id="outlined-basic"
									label={`Modified ${TERMS.QUOTA} vs Original ${TERMS.QUOTA}`}
									variant="outlined"
									size="small"
									sx={{
										width: "100%",
										mt : 3
									}}
									value={modificationDeviationPercentage}
									onChange={(event) => {
										const inputValue = parseFloat(event.target.value);
										if (isNaN(inputValue) || inputValue >= 0) {
											handleStateUpdate(event, "modificationDeviationPercentage")
										}
									}}
									InputProps={{ autoComplete: "off" }}
								/>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
			{/* <Box sx={{mt: 2}}>
				<Grid columns={12} item md={12} lg={12} alignContent={"flex-end"}>
					<Box list sm={2} 
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-start",
							float: "right" 
						}}
					>
						<FormControlLabel sx={{ mt: 0.3, alignContent: "flex-end", float: "right" }}
							control={
								<Checkbox
									checked={emailNotification}
									onChange={(event) =>
										handleCheckedUpdate(event, "emailNotification")
									}
									InputProps={{ "aria-label": "controlled" }}

								/>
							}
						/>

						<Typography sx={{ mt: 1.5, ml: -2, }}>
							Send Email Notification
						</Typography>
						<TextField
							id="outlined-basic"
							label="Email Address"
							variant="outlined"
							size="small"
							sx={{
								height: commonHeight,
								width: MW,
								ml: 2,
								mt: .5,
							}}
							value={email}
							onChange={(event) => handleStateUpdate(event, "email")}
							InputProps={{ autoComplete: "off" }}
						/>
					</Box>
				</Grid>
			</Box> */}
		</>
	);
}
